const Logo = (props) => (
    <img
      alt="Logo"
      src="/static/logo-neo-portal188.png"
      {...props}
    />
  );
  
  export default Logo;